import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Texte alternatif manquant pour cette image',
    noAnswers: 'Option Pas de réponse, veuillez cliquer sur Suivant pour continuer.',
    placeholder: 'Veuillez préciser...',
    pleaseSelect: 'Veuillez sélectionner...',
    rotateLandscape: 'Veuillez désactiver le verrouillage de l\'orientation sur votre téléphone et passer en mode paysage pour continuer.',
    rotatePortrait: 'Veuillez faire pivoter votre téléphone du mode paysage au mode portrait pour continuer.',
    ir: {
      selectWebCam:
        'Sélectionner la webcam (si disponible) ou cliquer sur "Rechercher" pour télécharger depuis votre appareil',
      noWebCam: 'Pas de webcam détectée',
      accessCamUpload: 'ACCÈS À LA CAMÉRA/TÉLÉCHARGEMENT',
      browse: 'RECHERCHER',
      uploadPhoto: 'Télécharger une photo',
      instead: 'à la place',
      capture: 'CAPTURER',
      somethingWrong: "Désolé, quelque chose n'a pas fonctionné. Veuillez réessayer plus tard.",
      couldntRead: 'Désolé, nous ne sommes pas parvenus à lire le code !',
      couldntProcess: "Désolé, nous n'avons pas pu traiter votre image !",
      moveOn: 'Veuillez essayer de nouveau ou soumettre votre photo et continuer',
      tryAgain: 'Veuillez réessayer',
      dataReceived: 'Données reçues !',
      enterManually: 'Veuillez réessayer ou entrer les données manuellement ci-dessous',
      positionQR:
        "Veuillez positionner le code QR en face de la caméra pour qu'il rentre dans le cadre rouge ou télécharger-le depuis votre ordinateur.",
      analyzing: "Analyse de l'image, veuillez patienter",
      submit: 'SOUMETTRE',
      startOver: 'Recommencer',
      allDone: 'Terminé !',
      cantAnalyze:
        "Attention - nous n'avons pas pu rendre cette image. Veuillez réessayer ou choisir un format d'image plus générique (JPG, PNG, GIF, BMP)",
      wrongFormat:
        "Nous sommes désolés, nous ne prenons pas en charge ce format de fichier. Veuillez télécharger un type d'image pris en charge (JPG, PNG, GIF, BMP, TIF, PDF, SVG)"
    },
    vr: {
      noWebCam: 'Pas de webcam détectée',
      uploadVideo: 'Charger une vidéo', // !
      skip: 'Passer ?',
      accessCamUpload: 'ACCÈS À LA CAMÉRA/TÉLÉCHARGEMENT',
      browse: 'RECHERCHER',
      instead: 'à la place',
      or: 'ou',
      stopRecording: "Arrêter l'enregistrement",
      willBeStopped: "L'enregistrement s'arrêtera après 5 minutes",
      stopOnDone: "Arrêtez d'enregistrer quand vous aurez fini !",
      record: 'ENREGISTRER',
      somethingWrong: "Désolé, quelque chose n'a pas fonctionné. Veuillez réessayer plus tard.",
      microphone: 'Microphone',
      camera: 'Web de travail',
      selectMicrophone: 'Sélectionnez votre microphone.',
      selectCam: 'Sélectionnez votre webcam',
      submit: 'SOUMETTRE',
      upload: 'TÉLÉCHARGER',
      playback: 'Lecture',
      stopPlayback: 'ARRÊTER',
      startOver: 'Recommencer',
      allDone: 'Terminé !',
      alternativeRecordSpan: 'Veuillez télécharger un clip vidéo depuis votre ordinateur.<br/>Vous pouvez &nbsp;',
      alrenativeRecordHref: 'aussi enregistrer la vidéo avec une webcam.',
      cantAnalyze:
        "Attention - nous n'avons pas pu rendre cette vidéo. Veuillez réessayer ou choisir un format vidéo plus générique (MP4, M4V, WEBPM)",
      wrongFormat:
        'Nous sommes désolés, nous ne prenons pas en charge ce format de fichier. Veuillez télécharger un type de vidéo pris en charge (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'CHOISIR',
      pleaseChoose: 'Veuillez choisir',
      this: 'CECI',
      one: 'un',
      myChoice: 'MON CHOIX'
    },
    hm: {
      addComment: 'Veuillez ajouter un commentaire ci-dessous',
      commentMandatoryPlaceHolder: 'Veuillez ajouter un commentaire obligatoire... ',
      commentOptionalPlaceHolder: 'Veuillez ajouter un commentaire facultatif... ',
      dragPin: 'Faites glisser pour repositionner (cliquer/appuyer long pour un épinglage précis).',
      removePin: "Faites glisser à l'extérieur de l'image pour supprimer.",
      editComment: "Cliquez/appuyez sur l'épingle pour modifier le commentaire.",
      addPin:
        "Veuillez faire glisser l'épingle du panneau ci-dessous et la déposer à l'endroit de votre choix sur l'image.",
      addPins:
        "Veuillez faire glisser les épingles du panneau ci-dessous et les déposer à l'endroit de votre choix sur l'image.",
      leavePins: (minPoints, maxPoints) =>
        `Veuillez laisser au moins ${minPoints} mais pas plus de ${maxPoints} épingles de chaque type.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Veuillez laisser au moins ${minPoints} mais pas plus de ${maxPoints} épingles.`,
      leavePinsWithOff: maxPoints =>
        `Veuillez ne pas laisser plus de ${maxPoints} épingles de chaque type ou cliquez sur Suivant pour passer.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Veuillez ne pas laisser plus de ${maxPoints} broches ou cliquez sur Suivant pour passer.`,
      leavePinWithOff: "Veuillez ne pas laisser plus d'une épingle de chaque type ou cliquez sur Suivant pour passer.",
      leavePinPerPageWithOff: "Veuillez ne pas laisser plus d'une épingle ou cliquez sur Suivant pour passer.",
      leaveExactlyPin: 'Veuillez laisser 1 épingle de chaque type.',
      leaveExactlyPinPerPage: 'Veuillez laisser 1 épingle.',
      leaveExactlyPins: maxPoints => `Veuillez laisser ${maxPoints} épingles de chaque type.`,
      leaveExactlyPinsPerPage: maxPoints => `Veuillez laisser ${maxPoints} épingles.`,
      leaveComment: "Appuyez sous l'image pour laisser un commentaire.",
      noAnswers: 'Option sans réponse, veuillez cliquer sur Suivant pour continuer.',
      outOfPins: "Vous n'avez plus d'épingles",
      pinsBehavior:
        "Lorsque vous vous déplacez à travers l'image, vous verrez des zones qui seront en surbrillance avec une seule broche.",
      clusters: 'Vous ne pourrez placer des broches que dans ces zones en surbrillance.',
      contentAware: "Vous pouvez déposer des broches à l'intérieur ou à l'extérieur des zones en surbrillance."
    },
    mp: {
      expand_note: "Veuillez glisser ou cliquer sur l'image(s) pour agrandir",
      rb_note: rows => `Veuillez sélectionner 1 réponse par élément${rows ? ' ci-dessous' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return "Cochez toutes les réponses qui s'appliquent:"
        } else if (min === max) {
          return `Veuillez sélectionner ${min} réponse${min !== 1 ? 's' : ''} seulement par article${
            rows ? ' ci-dessous' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Veuillez sélectionner au moins ${min} réponse${
            min !== 1 ? 's' : ''
          } mais pas plus que ${max} par article${rows ? ' ci-dessous' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Veuillez sélectionner au moins ${min} réponse${min !== 1 ? 's' : ''} par article${
            rows ? ' ci-dessous' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Veuillez ne pas sélectionner plus de ${max} réponse${max !== 1 ? 's' : ''} par article${
            rows ? ' ci-dessous' : ''
          }:`
        } else {
          return "Cochez toutes les réponses qui s'appliquent:"
        }
      }
    },
    sh: {
      note: "Cliquez sur un produit pour zoomer et ajoutez-le à votre panier virtuel si vous l'achetiez à la boutique",
      amazonNote: 'Cliquez sur un produit pour zoomer et l’ajouter à votre panier virtuel.',
      fullCart: 'Votre panier est plein !',
      qty: 'QTÉ',
      addToCart: 'AJOUTER AU PANIER',
      deleteFromCart: 'SUPPRIMER',
      each: 'chaque',
      items: 'articles',
      next: 'SUIVANT',
      emptyCard: 'Votre panier est vide',
      total: 'Panier',
      clearCart: 'Vider le panier',
      backToStore: 'Retour à la boutique',
      na: 'Aucune de ces réponses',
      maxCartCountError: max => `Veuillez ne pas ajouter plus de ${max} produits à votre panier`,
      scrollError: `Veuillez faire défiler l’écran entièrement vers la gauche et vers la droite pour poursuivre l’enquête. `,
      maxSpentError: max => `Veuillez ne pas dépenser plus de ${max}.`,
      maxProductCountError: max => `Veuillez ne pas ajouter à votre panier plus de ${max} articles du même produit.`
    },
    rb: {
      note: 'Veuillez sélectionner 1 point seulement:'
    },
    vo: {
      note: "Veuillez regarder la vidéo jusqu'à la fin"
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Veuillez sélectionner ${min !== 1 ? 'articles' : 'point'} ${min} seulement:`
        } else if (min > 0 && max < 5000) {
          return `Veuillez sélectionner au moins ${min} article${min !== 1 ? 's' : ''} mais pas plus que ${max}:`
        } else if (5000 === max && min > 0) {
          return `Veuillez sélectionner au moins ${min} article${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Veuillez ne pas sélectionner plus de ${max} article${max !== 1 ? 's' : ''}:`
        } else {
          return "Cochez toutes les réponses qui s'appliquent:"
        }
      }
    },
    oe: {
      na: "N'est pas applicable",
      note: (min, max, optional) => {
        if (min === max) {
          return `Veuillez taper exactement ${min} caractère${1 !== min ? 's' : ''}${optional ? ' (facultatif)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Veuillez taper au moins ${min} caractère${1 !== min ? 's' : ''} mais pas plus que ${max}${
            optional ? ' (facultatif)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Veuillez taper au moins ${min} caractère${1 !== min ? 's' : ''}${optional ? ' (facultatif)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Veuillez taper un maximum de ${max} caractère${1 !== min ? 's' : ''}${
            optional ? ' (facultatif)' : ''
          }:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Veuillez renseigner les champs suivants :'
    },
    mx: {
      note: 'Veuillez faire bouger les barres surlignées pour continuer',
      dragSlider: 'Faites glisser vers la gauche ou la droite pour répondre'
    },
    psc: {
      dragLeftRight: 'Faites glisser vers la gauche ou la droite pour répondre'
    },
    ps: {
      note: value => `Veuillez distribute ${value} restants entre les éléments ci-dessous`,
      allDone: 'Terminé !',
      total: `Total:`,
      dragSlider: 'Faites glisser vers la gauche ou la droite pour répondre'
    },
    cx: {
      note: 'Commencez à taper votre réponse à défilement automatique ou sélectionnez-la manuellement'
    },
    ro: {
      note: 'Faites glisser vers le haut ou le bas pour réorganiser:'
    },
    md: {
      note1:
        "Veuillez cliquer/appuyer sur l'élément que vous souhaitez sélectionner en premier<br/>Cliquez/appuyez à nouveau pour effacer votre sélection",
      note2:
        "Maintenant, veuillez cliquer/appuyer sur l'élément que vous souhaitez sélectionner en dernier<br/>Cliquez/appuyez à nouveau pour effacer votre sélection.",
      note3:
        'Merci ! Passez à la question suivante<br/>ou cliquez/appuyez sur un élément non sélectionné pour recommencer.'
    },
    aro: {
      note: 'Veuillez choisir un élément pour chaque paire'
    },
    wd: {
      note: 'Assurez-vous que chaque valeur ultérieure est supérieure à la précédente.'
    },
    emd: {
      note: "Veuillez regarder la vidéo jusqu'à la fin",
      noAnswers: 'Option Pas de réponse, veuillez cliquer sur Suivant pour continuer.',
      start: 'Cliquez et maintenez pour commencer',
      resume: 'Cliquez et maintenez pour reprendre',
      continue: 'Vous avez terminé ! <br /> Cliquez sur suivant pour continuer',
      continueMobile: 'Vous êtes prête ! <br /> Cliquez ICI pour continuer',
      training: {
        session: 'session de formation',
        note: "Veuillez terminer l'entraînement",
        moveLeft: 'Veuillez faire glisser le cadran complètement vers la gauche',
        moveBottom: 'Veuillez faire glisser le cadran complètement vers le bas',
        moveRight: 'Maintenant faites glisser le cadran complètement vers la droite',
        moveTop: 'Maintenant faites glisser le cadran complètement vers le haut',
        success: 'Excellent !'
      }
    },
    sft: {
      noAnswers: 'Option Pas de réponse, veuillez cliquer sur Suivant pour continuer.',
      note: 'Donnez aussi vite que possible réponse qui vous semble intuitivement la plus juste',
      finish: "C'est fait !<br />  Veuillez cliquer sur Suivant pour continuer",
      training: {
        start:
          '<p>Cette question vous montrera rapidement différents mots et exigera votre concentration. ' +
          'Tout doit maintenant aller très vite.</p> <p>Prêt à pratiquer ?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Appuyez sur "{buttonLeft}"`
            : (mouse ? `Cliquez sur "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Appuyez sur la touche « F »` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Appuyez sur "{buttonRight}"`
            : (mouse ? `Cliquez sur "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Appuyez sur la touche « J »` : ''),
        fail: () => 'Trop lent',
        success: () => 'Super !',
        finish: () =>
          '<p><strong> Excellent !</strong></p><p>Veuillez vous assurer que rien<br />' +
          'ne va vous distraire <br/> dans les 2-3 prochaines minutes</p><p>Cliquez sur Suivant lorsque vous serez prêt.</p>'
      },
      buttons: {
        start: 'Démarrer',
        yesno: {
          left: 'Oui',
          right: 'No'
        },
        matches: {
          left: 'Correspond',
          right: 'Ne correspond pas'
        },
        fits: {
          left: 'Convient',
          right: 'Ne convient pas'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
